/* jshint esversion:6*/
class CustomModule {
	constructor(AppWeb = null){
		this.AppWeb = AppWeb;
	}

	toogleContact() {
		$('.page_contact_form').css('visibility', 'visible');
		$('.page_contact_form').slideToggle('slow','swing');
		console.log("Toogle");
		$('html, body').animate({
		scrollTop: $("#frm_contact").offset().top - 80 }, 'slow');
		$('#frm_contact').focus();
	}
	closeContactUp() {
		$('.page_contact_form').slideUp('slow', 'swing');
	}

	bindAll(context){
		$('#web-message [role=close]').on('click', function(){
			$('#web-message').remove();
		});

	}
}

module.exports = CustomModule;



// WEBPACK FOOTER //
// ./C:/wamp64/www/deporduel/devel/js/custom.js